import {useNavigate} from 'react-router-dom'
import st from './News.module.scss'
import {formatDate} from 'helpers'

export const NewItem = ({ data })=> {
    const navigate = useNavigate()
    const pusher = (id=1)=> ()=> {
        window.scroll({ top: 0, behavior: 'smooth' })
        navigate('/news/'+id)
    }

    return (
        <div className={st.item} onClick={pusher(data.id)}>
            <div className={st.item_img}>
                <picture>
                    <img src={data.url_image} alt=""/>
                </picture>
            </div>
            <div className={st.item_content}>
                <p className={st.item_desc}>
                    {data.title}
                </p>
                <div className={st.item_date}>
                    {formatDate(data.date_created)}
                </div>
            </div>
        </div>
    )
}
